class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    //this.notification.classList.add('animate', 'active'); // disable cart notification
    // show mini cart when add to cart product
    $('.mini-cart-content #mincart-loading').show();
    this.refreshMiniCart();
    $('body').addClass('open-minicart');
    $('.mini-cart-wrapper').toggleClass('show');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

      /* MINICART FUNCTIONS */
    //reinit minicart
    refreshMiniCart(lineitem, quantity) {
      $.ajax({
          method: "GET",
          url: "/cart",
          data: {"view": "ajax"},
          xhrFields: {
              withCredentials: true
          },
          dataType: 'html',
          success: function(response) {

              var CartCount = $(response).find('.cartCount').html();
              // console.log(CartCount);
              var contentCartHtml = $(response).find('.mini-cart-wrapper').first().html();
              //console.log(contentCartHtml);
              if(CartCount == undefined){
                  CartCount = 0;
                  $('.cart-count-bubble').addClass('hidden');
              } else {
                  $('.cart-count-bubble').removeClass('hidden');
              }

              $('.cartCount').text(CartCount);

              if (contentCartHtml) {
                  $('.mini-cart-wrapper').html(contentCartHtml);
              }
          }
      });
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
